import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m13.376 14.432 3.212-3.13c1.275-1.245.41-3.41-1.371-3.433l-6.343-.08c-1.781-.023-2.701 2.12-1.457 3.395l3.13 3.212a2 2 0 0 0 2.829.036"
    }
  )
);
var SvgArrowDownFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ArrowDownFilled_default = SvgArrowDownFilled;

export { ArrowDownFilled_default as default };
